import classNames from "classnames";

export function Divider({ className }: { className?: string }) {
    return <div className={classNames("border-t-2 border-main/10", className)}></div>;
}